export default "__VITE_ASSET__Cpq$GhfP__";